/**
 * Markdown — 서버가 내려준 마크다운 원문을 안전하게 렌더한다.
 *   - remark-gfm 로 표·체크리스트·자동링크 등 GFM 문법 지원.
 *   - raw HTML 은 기본값(무시)로 두어 XSS 를 차단한다(1st-party 콘텐츠라도 rehype-raw 미도입).
 *   - 시각 스타일은 감싸는 쪽의 `.legal-prose`(globals.css)가 태그 선택자로 입힌다.
 *   - 태그를 감싸야 할 때(표 가로 스크롤 등)는 `components` 로 바꿔 끼운다.
 * 서버 컴포넌트에서 그대로 렌더 가능(클라이언트 전용 기능 없음).
 */
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({
  children,
  components,
}: {
  children: string;
  components?: Components;
}) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {children}
    </ReactMarkdown>
  );
}
